import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { SubscriptionBillingLockService } from 'src/app/private/services/subscription-billing-lock.service';

const BILLING_PATH = '/main/billing-subscription';

function isBillingPath(url: string): boolean {
  const path = (url || '').split('?')[0];
  return path === BILLING_PATH || path.startsWith(`${BILLING_PATH}/`);
}

/**
 * After login, if the client has no subscription or is in a hard-blocked subscription state,
 * only `/main/billing-subscription` is reachable until an active package is available.
 */
export const subscriptionBillingLockGuard: CanActivateFn = (
  _route,
  state
): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const lockSvc = inject(SubscriptionBillingLockService);

  return lockSvc.ensureActivePackageForClient().pipe(
    map(() => {
      if (!lockSvc.isBillingRouteLockActive()) {
        return true;
      }
      if (isBillingPath(state.url)) {
        return true;
      }
      return router.createUrlTree(['/main/billing-subscription']);
    }),
    catchError(() => of(true))
  );
};
